import {CustomerBlackListState} from "../store/customer_black_list_state";
import {Reducer} from "redux";
import {
    CustomerBlackListAction,
    CustomerBlackListActionType, ICallbackAddCustomerBlackListAction, ICallbackDeleteCustomerBlackListAction,
    ICallbackGetCustomerBlackListAction,
} from "../action/customer_black_list_action";

const initialState: CustomerBlackListState = {
    customerBlackList: null,
    isLoading: false,
};

const customerBlackListReducer: Reducer<CustomerBlackListState> = (state = initialState, action: CustomerBlackListAction): CustomerBlackListState => {
    switch (action.type) {

        case CustomerBlackListActionType.REQUEST_GET_CUSTOMER_BLACK_LIST: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CustomerBlackListActionType.CALLBACK_GET_CUSTOMER_BLACK_LIST: {
            const _action = action as ICallbackGetCustomerBlackListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customerBlackList: _action.item ? _action.item.customerBlackList : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case CustomerBlackListActionType.REQUEST_ADD_CUSTOMER_BLACK_LIST: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CustomerBlackListActionType.CALLBACK_ADD_CUSTOMER_BLACK_LIST: {
            const _action = action as ICallbackAddCustomerBlackListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customerBlackList: _action.item ? _action.item.customerBlackList : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case CustomerBlackListActionType.REQUEST_DELETE_CUSTOMER_BLACK_LIST: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CustomerBlackListActionType.CALLBACK_DELETE_CUSTOMER_BLACK_LIST: {
            const _action = action as ICallbackDeleteCustomerBlackListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customerBlackList: _action.item ? _action.item.customerBlackList : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default customerBlackListReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_black_list_reducer.ts